module.exports = __webpack_public_path__ + "static/media/no_products_icon.69bbdfa6.svg";